export default __webpack_public_path__ + "static/media/notfound.bcf5207b.svg";